var t=function(t){return t.left="left",t.right="right",t.center="center",t}({});export{t as TextAlign};
//# sourceMappingURL=TextAlign.js.map
